import { FC } from "react";

import { t } from "i18n/i18n";
import { Switch } from "mds/components/ToggleSwitch";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectIsAssessWithAIModeEnabled, selectIsRecordingFeedbackStyle } from "store/selectors";
import { aiStateActions } from "store/slices/ai";
import { isAssessmentAIFeedbackStyleEnabled } from "utils/waffle-flags";

export const AssessWithAIModeButton: FC = () => {
  const dispatch = useAppDispatch();
  const isAssessWithAIModeEnabled = useAppSelector(selectIsAssessWithAIModeEnabled);
  const isRecordingAssessmentStyle =
    useAppSelector(selectIsRecordingFeedbackStyle) && isAssessmentAIFeedbackStyleEnabled();

  const toggleAssessWithAi = () =>
    dispatch(aiStateActions.setAssessWithAIMode(!isAssessWithAIModeEnabled));

  return (
    <div className="flex flex-col gap-1">
      <SquareButton
        className="w-full justify-between"
        disabled={isRecordingAssessmentStyle}
        eventName="Assessment - Auto AI suggestions toggle"
        isSelected={isAssessWithAIModeEnabled}
        kind="toggle"
        size="m"
        onClick={toggleAssessWithAi}
      >
        {t("assessment_card.ai.toggle")}
        <Switch checked={isAssessWithAIModeEnabled} disabled={isRecordingAssessmentStyle} />
      </SquareButton>
    </div>
  );
};
